import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import {
  CardStyled,
  Icon,
  InnerWrapper,
  MainView,
  TextWrapper,
  Title,
} from './styled';
import useCard from './useCard';

export default function Card({ children, title, isOpened, onClick }) {
  const { textRef } = useCard({ isOpened });

  return (
    <CardStyled onClick={onClick}>
      <MainView>
        <Title>{title}</Title>
        <Icon icon={faChevronDown} isOpened={isOpened} />
      </MainView>
      <TextWrapper ref={textRef}>
        <InnerWrapper>{children}</InnerWrapper>
      </TextWrapper>
    </CardStyled>
  );
}
